$(document).ready(function(){
  $('.brand_wrapper_2').slick({
    rows: 3,
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('.prod_main_slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      fade: true,
      asNavFor: '.prod_nav_slider'
   });
  $('.prod_nav_slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.prod_main_slider',
      dots: false,
      vertical: true,
      arrows:false,
      focusOnSelect: true,
     responsive: [
          {
            breakpoint: 768,
            settings: {
              vertical: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              vertical: false
            }
          }
        ]
    });
  $('.tesimonial_slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2700,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: 'linear'
  });
  $('.instructors_quotes_wrapper').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('.slider_compare').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $('.premium-slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3.7,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.7,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.9,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
  $('.premium-slider_product').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3.7,
      slidesToScroll: 1,
      arrows:true,
      prevArrow: $('.left_btn'),
      nextArrow: $('.right_btn'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.7,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.9,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
  $('.coach_client_say').slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed:  300,
    lazyLoad: 'progressive',
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  }).slickAnimation();
  $('.team_slider').slick({
    dots: false,
    infinite: false,
    slidesToShow: 3.25,
    slidesToScroll: 1,
    arrows:true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.25,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  $('.schedule_slider').slick({
    dots: false,
    infinite: false,
    slidesToShow: 3.9,
    slidesToScroll: 1,
    arrows:true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  $('.coach_related_slider').slick({
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  $('.brand_slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 5.6,
    slidesToScroll: 1,
    arrows:false,
    swipeToSlide: true,
    autoplay: true,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed: 5000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  $('.marketing_brand_slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4.6,
    slidesToScroll: 1,
    arrows:false,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed: 5000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.6,
          slidesToScroll: 1,
        }
      }, 
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  $('.guidance_slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1
          }
        }
      ]
    });
  $('.guidance_slider_mob').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  $('.quiz_result_mob').slick({
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
    });
  const slider = $('.main_content_wrapper');
  
  function onSliderAfterChange(event, slick, currentSlide) {
    $(event.target).data('current-slide', currentSlide);
  }
  
  function onSliderWheel(e) {
    var deltaY = e.originalEvent.deltaY,
      $currentSlider = $(e.currentTarget),
      currentSlickIndex = $currentSlider.data('current-slide') || 0;
    
    if ( (deltaY < 0 && currentSlickIndex == 0) ||(deltaY > 0 && currentSlickIndex == $currentSlider.data('slider-length') - 1)) {
      return;
    }

    e.preventDefault();

    if (e.originalEvent.deltaY < 0) {
      $currentSlider.slick('slickPrev');
    } else {
      $currentSlider.slick('slickNext');
    }
  }
  
  slider.each(function(index, element) {
    var $element = $(element);
    $element.data('slider-length', $element.children().length);
  })
  .slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    vertical: true,
  	cssEase: 'ease-out',
    speed: 750,
    centerMode: true
  })
  .on('afterChange', onSliderAfterChange)
  .on('wheel', onSliderWheel);

  mobileOnlySlider(".plans_row_wrapper", false, false, 801, true);

  function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint, $centermode) {
    var slider = $($slidername);
    var settings = {
      infinite: false,
      mobileFirst: true,
      dots: $dots,
      arrows: $arrows,
      centerMode: $centermode,
      centerPadding: '20px',
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };
  
    slider.slick(settings);
  
    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  }
  
$('.main_content_wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
  var dataId = $(slick.$slides[currentSlide]).data('slick-index'); 
  var dataIndex = dataId + 1;
  //   console.log(dataIndex);
  var MainSlideParents = $(this).parents('.sticky_wrapper');

  $(MainSlideParents).find('.img_box').removeClass('will_change');
  $(MainSlideParents).find(".img_box_"+dataIndex+"").addClass('will_change');
});

$('.collapse_tigger').click(function(){
  //$(this).parents('.collapse_wrapper').find('.collapse_content').slideToggle();
  //$(this).toggleClass('opened');

  $('.collapse_wrapper').find('.collapse_content').slideToggle();
  $('.collapse_wrapper .collapse_tigger').toggleClass('opened');
});

//promo bar Modal
$('.promo_modal').click(function(){
    $('body').addClass('promo_modal_opened');
});
$('.promo_close_btn, .backdrop_box').click(function(){
     $('body').removeClass('promo_modal_opened');
});


$('.menu_icon').click(function(){
  $('body').addClass('opened_menu_drawer');
});
$('.close_icon').click(function(){
  $('body').removeClass('opened_menu_drawer');
});

var url = document.location.href;
$('.menu_box .menu_ul li').removeClass('active_link');
$('.menu_box .menu_ul li a').filter(function() {
    return this.href == url;
}).parent().addClass('active_link');

var str1 = window.location.href;
var str2 = "/blogs/trainers";
var str3 = "/pages/hardware";
var str4 = "/products/forme-lift"; 
var str5 = "/products/forme-studio";
var str6 = "/products/barre-bundle";
var str7 = "/?_ab=0&_fd=0";
if(str1.indexOf(str2) != -1){
     $('.header__menu-item[href="/blogs/trainers"], .drawer_a_trainers').addClass('active_link');
}else if(str1.indexOf(str3) != -1 || str1.indexOf(str4) != -1 || str1.indexOf(str5) != -1 || str1.indexOf(str6) != -1 )  {
  $('.header__menu-item[href="/pages/hardware"], .drawer_a_hardware').addClass('active_link');
}else if(str1.indexOf(str7) != -1){
     $('.drawer_a_training').addClass('active_link');
}else{
    $('.header__menu-item, .drawer_a_trainers, .drawer_a_hardware').removeClass('active_link');
}
  
//plans
  $('.btn_affirm').click(function(){
    $('body').addClass('affirm_opened');
  });

  $('.close_btn').click(function(){
    $('body').removeClass('affirm_opened');
  });
  
//slider video pause and play
$('.video_box').mouseenter(function () {
  $(this).click();
  $(this).get(0).play();
}).mouseleave(function () {
  $(this).get(0).pause();
});

  
//mfp popup
// $('.video_modal').magnificPopup({
//   disableOn: 700,
//   type: 'iframe',
//   mainClass: 'mfp-fade',
//   removalDelay: 160,
//   preloader: false,
//   fixedContentPos: false
// });
$('.video_modal').magnificPopup({
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 400,
	preloader: false,
	iframe: {
		patterns: {
			youtube: {
				index: 'youtube.com',
				id: 'v=',
				src: 'https://www.youtube.com/embed/%id%?rel=0&autoplay=1&loop=1'
			}
		}
	},
});


//b2b QR modal
$('.modal_btn_QR').click(function(){
  $('body').addClass('QRmodal_opened');
});

$('.QR_close_btn').click(function(){
  $('body').removeClass('QRmodal_opened');
});

//faqs
$('.question_faq').click(function(){
  if ($(this).hasClass("opened")) {
    $(this).removeClass("opened");
    $(this).next().removeClass("opened_ans");
  }else{
    $(this).addClass("opened");
    $(this).next().addClass("opened_ans");
  }
});


//B2B faqs
$('.title_faq').click(function(){
  if ($(this).hasClass("opened")) {
    $(this).removeClass("opened");
    $(this).next().removeClass("opened_ans");
  }else{
    $('.main_faq_box .title_faq').removeClass("opened");
    $('.main_faq_box .content_wrapper').removeClass("opened_ans");
    $(this).addClass("opened");
    $(this).next().addClass("opened_ans");
  }
});


//modal wrapper
$(document).on('click','.popup_btn',function(){
  var popup_modal = $(this).parents('.product_box, .variant_inner_wrapper').find('.modal_wrapper');
  $('body').addClass('modal_opened');
  $('#modal_nitty_gritty').fadeIn();
  $(popup_modal).fadeIn();
});

$('.close_btn_modal').click(function(){
  var popup_modal_close = $(this).parents('.product_box, .variant_inner_wrapper').find('.modal_wrapper');
  $('#modal_nitty_gritty').fadeOut();
  $(popup_modal_close).fadeOut();
  $('body').removeClass('modal_opened');
});

$('.modal_backdrop').click(function(){
  var popup_close = $('body').find('.product_box, .variant_inner_wrapper').find('.modal_wrapper');
  $(popup_close).fadeOut();
  $('body').removeClass('modal_opened');
  $('body').removeClass('showed_welcome_popup');
  $('.footer_welcome_popup, .welcome-popup').hide();
});


//studio builder cart tab
// $(document).on('click','#cart_wrapper .tab_header .tab_head',function(){
//   let Parents_main = $(this).parents('.tab_section');
//   $('.cart_wrapper .tab_header .tab_head').addClass("active_tab");
//   $(this).removeClass("active_tab");
  
//   let data_id = $(this).parents('.tab_header').find('.active_tab').attr('data_id');
//   $('.content_inner').removeClass('active_content');
//   $(Parents_main).find('#'+ data_id).addClass('active_content');
// });
$(document).on('click','#cart_wrapper .tab_header .tab_head',function(){
  let Parents_main = $(this).parents('.tab_section');
  let data_id = $(this).attr('data_id');

  $('.content_inner').removeClass('active_content');
  $(Parents_main).find('.'+ data_id).addClass('active_content');
  $('.cart_wrapper .tab_header .tab_head').removeClass("active_tab");
  $(this).addClass("active_tab");
});

//Price change whole page Js
$(document).on('click','.price_change_item',function(){
  if ($('.price_change_item').hasClass("purchase_price")) {
      $('.price_change_item').removeClass('purchase_price');
      $('.price_change_item').addClass('financing_price');
      $('.prod_purchase_price').hide();
      $('.prod_finance_price').show();
  }else{
      $('.price_change_item').removeClass('financing_price');
      $('.price_change_item').addClass('purchase_price');
      $('.prod_finance_price').hide();
      $('.prod_purchase_price').show();
  }
});

  

//product variant
$(document).on('click','.variant_changer_title',function(){
  $('.variant_changer_title').removeClass('active_variant_title');
  $(this).addClass('active_variant_title');
  var variantShow = $(this).attr('data-name');
  var variantTitle = $(this).attr('data-title');
  $('.variant_inner_wrapper').removeClass('active_variant');
  $('.variant_'+variantShow).addClass('active_variant');
  $('.product_sliders').removeClass('active_variant');
  $('.'+variantShow+'_wrapper').addClass('active_variant');
  $('.product__title').text(variantTitle);
});



//cart-drawer tab

  $(document).on('click','.main_cart_wrapper .drawer_tab_header .drawer_tab_head',function(){
  let DrawerParents = $(this).parents('.drawer_tab_section');
  let DrawerData_id = $(this).attr('data_id');

  $('.drawer_content_inner').removeClass('active_content');
  $(DrawerParents).find('.'+ DrawerData_id).addClass('active_content');
  $('.main_cart_wrapper .drawer_tab_header .drawer_tab_head').removeClass("active_tab");
  $(this).addClass("active_tab");
});

//studio builder sticky cart tab mobile
// $('.sticky_product_details .sticky_tab_header .sticky_tab_head').click(function(){
//   let stickyParents = $(this).parents('.sticky_tab_section');
//   $('.sticky_product_details .sticky_tab_header .sticky_tab_head').addClass("active_tab");
//   $(this).removeClass("active_tab");
  
//   let stickyData_id = $(this).parents('.sticky_tab_header').find('.active_tab').attr('data_id');
//   $('.sticky_content_inner').removeClass('active_content');
//   $(stickyParents).find('.'+ stickyData_id).addClass('active_content');
// });

$('.sticky_product_details .sticky_tab_header .sticky_tab_head').click(function(){
  let stickyParents = $(this).parents('.sticky_tab_section');
  let stickyData_id = $(this).attr('data_id');

  $('.sticky_content_inner').removeClass('active_content');
  $(stickyParents).find('.'+ stickyData_id).addClass('active_content');
  $('.sticky_product_details .sticky_tab_header .sticky_tab_head').removeClass("active_tab");
  $(this).addClass("active_tab");
});  
  


//sticky on/off
$('.sticky_handle').click(function(){
  $(this).hide();
  $('.main_wrapper_sticky').show();
  $('body').addClass('sticky_cart_opened');
});

$('.close_btn_sticky').click(function(){
  $('.sticky_handle').show();
  $('.main_wrapper_sticky').hide();
  $('body').removeClass('sticky_cart_opened');
});


  $(".studio_block").click(function(e) {
    $('html, body').animate({
      scrollTop: $("body").offset().top
    }, 1000);
  });

  $(".addon_block").click(function(e) {
    $('html, body').animate({
      scrollTop: $("#product_box_3").offset().top - 300
    }, 1000);
  });

  $(".accessories_block").click(function(e) {
    $('html, body').animate({
      scrollTop: $("#accessories").offset().top - 300
    }, 1000);
  });
  
});


      
//D2c Plan accordion
if ($(window).width() <= 991) {
  $('.plan_top h3').click(function(){
    var planParent = $(this).parents('.plan_box');
    var planMainParent = $(this).parents('.row_wrapper');
    $(planMainParent).find('.plan_box').removeClass('opened_plan');
    $(planParent).addClass('opened_plan');
  });
}
else {
  $('.plan_top h3').bind('unclick');
}
if ($(window).width() <= 600) {
  if (navigator.userAgent.match(/iPhone/)) {
      $('.iphone_QR').css("display", "flex");
      $('.android_QR').css("display", "none");
  }
  if (navigator.userAgent.match(/Android/)) {
     $('.android_QR').css("display", "flex");
     $('.iphone_QR').css("display", "none");
  }
}else{
  $('.mob_QR').css("display", "none");
}
if ($(window).width() <= 767) {
   //new lift page
  $('.title_box').click(function(){
    if ($(this).hasClass("opened_nav")) {
      $(this).removeClass("opened_nav");
      $(this).parents('.content_box').removeClass("opened");
    }else{
      $(this).addClass("opened_nav");
      $(this).parents('.content_box').addClass("opened");
    }
  });
}
else {
  $('.title_box').bind('unclick');
}


// B2B scroll section
if(window.location.href.indexOf("/pages/vip-clients") > -1){
  //comparison section
  const imageComparisonSlider = document.querySelector('[data-component="image-comparison-slider"]')

  function setSliderstate(e, element) {
    const sliderRange = element.querySelector('[data-image-comparison-range]');

    if (e.type === 'input') {
      sliderRange.classList.add('image-comparison__range--active');
      return;
    }

    sliderRange.classList.remove('image-comparison__range--active');
    element.removeEventListener('mousemove', moveSliderThumb);
  }

  function moveSliderThumb(e) {
    const sliderRange = document.querySelector('[data-image-comparison-range]');
    const thumb = document.querySelector('[data-image-comparison-thumb]');
    let position = e.layerY - 20;

    if (e.layerY <= sliderRange.offsetTop) {
      position = -20;
    }

    if (e.layerY >= sliderRange.offsetHeight) {
      position = sliderRange.offsetHeight - 20;
    }

    thumb.style.top = `${position}px`;
  }

  function moveSliderRange(e, element) {
    const value = e.target.value;
    const slider = element.querySelector('[data-image-comparison-slider]');
    const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

    slider.style.left = `${value}%`;
    imageWrapperOverlay.style.width = `${value}%`;

    element.addEventListener('mousemove', moveSliderThumb);
    setSliderstate(e, element);
  }

  function init(element) {
    const sliderRange = element.querySelector('[data-image-comparison-range]');

    if ('ontouchstart' in window === false) {
      sliderRange.addEventListener('mouseup', e => setSliderstate(e, element));
      sliderRange.addEventListener('mousedown', moveSliderThumb);
    }

    sliderRange.addEventListener('input', e => moveSliderRange(e, element));
    sliderRange.addEventListener('change', e => moveSliderRange(e, element));
  }

  init(imageComparisonSlider);
}




//redirect URL
if(window.location.href.indexOf("/pages/install-guide") > -1){
  window.location.href="https://formelife.com/FORME_Installation_Guidelines.pdf";
}

if(window.location.href.indexOf("/collections") > -1){
  window.location.href="/";
}
if(window.location.href.indexOf("/collections/all-1") > -1){
  window.location.href="/";
}

// $(window).scroll(function(){
//   if ($(window).scrollTop() >= 55) {
//     $('body').addClass('header_fixed');
//    }
//    else {
//     $('body').removeClass('header_fixed');
//    }
// });
window.onscroll = function(){
  fixedHeader();
};

var header = document.getElementById("header");
var sticky = header.offsetTop;

function fixedHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed-header");
  } else {
    header.classList.remove("fixed-header");
  }
}
$(window).scroll(function(){
    if ($(window).scrollTop() >= 20) {
        $('body').addClass('CTA-visibled');
    }
    else {
        $('body').removeClass('CTA-visibled');
    }
});

//animation class add
if(window.location.href.indexOf("/pages/classes") > -1){
  let children = document.querySelectorAll('.text_box');
  let i = 0;
  setInterval((e)=>{
    let ele = children[i];
    ele.classList.add("color_anim");
      if(children.length == i+1){
        setTimeout(()=>{
                   for (let j = 0; j < children.length; j++) {
          children[j].classList.remove("color_anim");
        }
        i = 0;
      },400);
      }else{
        i++;
      }      
  },400);
}

setTimeout(function() {
  // jQuery('.live_chat_btn').click(function(){ 
  //   $('#main-chat-btn').click();
  // });
  jQuery('.live_chat_btn').click(function() { Beacon('open') });
}, 1500);

//barrys form api call
$(".Sample_form").submit(function(e){
  var form = $(this);
  e.preventDefault();
  $.ajax({
    type: 'POST',                             
    url: 'https://links.iterable.com/lists/publicAddSubscriberForm?publicIdString=a20e8d13-a40b-4d6f-8eba-1e0393239e30',
    data: form.serialize(),
    success: function(data) {
      //       console.log('sucess', data);
      localStorage.setItem('ajs_user_traits', data);
      localStorage.setItem('isSubmited', true);
      $('.form_hide').hide();
      $('.submitted_content').show();
      $('.form_msg_wrapper').show();
    },
    error: function(xhr, resp, text) {
      console.log(xhr, resp, text);
    }
  });
});

$('.checkout_btn').click(function(){
  localStorage.setItem('isCheckout', true);
});

//video play pause
$('.volume_btn, .fullscreen_btn').hide();
$('.video, .play_btns, .fullscreen_btn').click(function(e){
    e.preventDefault();
    $('.volume_btn, .fullscreen_btn').show();
    $('body').addClass('modal_video_opened');
    $('#video_modal').trigger('play');
    VideoPlays();
});

$('.close_btn_video').click(function(){
    var videoPauseImg = $('#video_modal').attr('poster'); 
    $('body').removeClass('modal_video_opened');
    $('#video_modal').trigger('pause');
    $('.video_wrapper .video').attr('poster', videoPauseImg);
    console.log(videoPauseImg);
    VideoPlays();
});

$('.volume_btn').click(function(e){
    e.preventDefault();
    var videoMute = $(this).parents('.video_wrapper').find('.video'); 
    if ($(this).hasClass("volume_mute")) {
      $(this).removeClass('volume_mute');
      $('#video_modal').prop('muted', false);
    }else{
      $(this).addClass('volume_mute');
      // $(videoMute).prop('muted', true);
      $('#video_modal').prop('muted', true);
    }
});

function VideoPlays(){
    var playBtns = $('.video_wrapper').find('.play_btns');
    var videoPlayer = $('.video_wrapper').find('.video');
    if ($(playBtns).hasClass("play_video") && videoPlayer.trigger('pause')) {
       // videoPlayer.trigger('play');
       $(playBtns).removeClass('play_video').addClass('pause_video');
       $('.video, .play_btns').parents('.video_wrapper').addClass("video_played");
    }else{
       // videoPlayer.trigger('pause');  
       $(playBtns).removeClass('pause_video').addClass('play_video');
       $('.video, .play_btns').parents('.video_wrapper').removeClass("video_played");
    }
}


// $('.fullscreen_btn').click(function(e){
//     e.preventDefault();
//    var videoFull = $(this).parents('.video_wrapper').find('.video');
//    if(!videoFull.webkitEnterFullscreen || !videoFull.requestFullscreen){
//       $(videoFull)[0].webkitEnterFullscreen();
//       // $(videoFull)[0].requestFullscreen();
//    }
// });

// $(document).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
//     var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
//     var event = state ? 'FullscreenOn' : 'FullscreenOff';
//     var videoFull2 = $('.video_wrapper').find('.video');
//      if(event === 'FullscreenOff') {
//        // console.log('video exit full');
//        videoFull2.trigger('pause');  
//        $('.play_btns').removeClass('pause_video').addClass('play_video');
//        $('.video, .play_btns').parents('.video_wrapper').removeClass("video_played");
//        $(videoFull2).removeClass('video_full');
//      } else {
//        // console.log('video in full');
//        $(videoFull2).addClass('video_full');
//      }
// });

//modal wrapper barry's VIP
//modal wrapper
$('.modal_trigger').click(function(){
  var popupModal = $(this).parents('.product_box').find('.modal_wrapper');
  $('body').addClass('modal_opened');
  $(popupModal).fadeIn();
});

$('.barry_quipment .close_btn_modal').click(function(){
  var popupModalClose = $(this).parents('.product_box').find('.modal_wrapper');
  $(popupModalClose).fadeOut();
  $('body').removeClass('modal_opened');
});

//product options
$('.option_box input[type="radio"]').on('change', function(){
  var selectedVal = $(this).val();
  //   		console.log(selectedVal);

  var Formselect = $(this).parents('.content_wrapper').find('.product-single__variants');
  $(Formselect).find('option[data-label="'+ selectedVal +'"]').prop('selected', 'selected');
  var valSelect = $(Formselect).find("option:selected" ).val();
  // console.log(valSelect);
});

$('.lock_box').click(function(){
  $(this).hide();
  $(this).parents('.overlay_form').find('.form_box').show();
});


const installments = document.querySelectorAll('[data-upddate-installments]')
installments.forEach(installment => {
  const amount = installment.getAttribute('data-upddate-installments');
  const per_installment = amount / 48;
  const ceil_installment = Math.ceil(per_installment);
  console.log(amount+ ' > ' + per_installment + ' > ' + ceil_installment);
  installment.innerText = '$'+ ceil_installment + '/mo'
})


// var delay = 5000; //in milleseconds






function copyCode() {
  // Get the text field
  var copyText = document.getElementById("copy_input");

  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices

  // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);
  
  // Alert the copied text
  // alert("Copied the text: " + copyText.value);
}

$('.copy_btn').on('click', function() {
    copyCode();
    $(this).addClass('copy_txt');
});







// $("#popup_form, #fotter_popup_form").validate({
//     rules: {
//       email: {
//         required: true,
//         email: true
//       }
//     },
//     messages : {
//       email: {
//         required: "Please enter valid email address",
//         email: "Please enter valid email address"
//       }
//     }
//   });


$("#popup_form").submit(function(e) {
    e.preventDefault();   
    
    var form = $(this);
    var actionUrl = form.attr('action');
      $.ajax({
          type: "POST",
          url: actionUrl,
          data: form.serialize(), 
          success: function(data){
            $(".newsletter-form__button .submit_btn_success").show();
            $(".newsletter-form__button .submit_btn").hide();
            $('.welcome-popup').addClass('popup_top');
            setTimeout(function() {
              $('#popup_form #newsletter-popup').addClass('hidden_wrapper form_remove');
              $('#popup_form #code_wrapper').addClass('show_wrapper form_add');
              setTimeout(function() {
                $('.popup_colse_btn').click();
              }, 3000);
            }, 500);
          }, 
          error: function (data) {
            
          }
      });
});

$("#fotter_popup_form").submit(function(e) {
   if ( $(this)[0].checkValidity()) {
      e.preventDefault();
      var form = $(this);
      var actionUrl = form.attr('action');
      $.ajax({
          type: "POST",
          url: actionUrl,
          data: form.serialize(), 
          success: function(data){
            $(".newsletter-form__button .submit_btn_success").show();
            $(".newsletter-form__button .submit_btn").hide();
            setTimeout(function() {
              $('.footer_welcome_popup').addClass('submitted_form_newsletter');
              $("#fotter_popup_form .left_wrapper").show();
              $('#fotter_popup_form #newsletter-popup').addClass('hidden_wrapper form_remove');
              $('#fotter_popup_form #code_wrapper').addClass('show_wrapper form_add');
            }, 700);
          }, 
          error: function (data) {
          }
      });
   }
});





// $(".product_form").submit(function(e) {
//     e.preventDefault();
//     var form = $(this);
//     var actionUrl = form.attr('action');
//     $.ajax({
//         type: "POST",
//         url: actionUrl,
//         data: form.serialize(), 
//         success: function(data){
//           $('body').addClass('js-my-cart-open');
//         }, 
//         error: function (data) {
          
//         }
//     });
// });






  //Quiz   js
    // if($('.current_option_row .option_box input:checked').prop('checked')) {
    //      $('#next').removeAttr("disabled");
    // }
    
    // let allvalues = [];
    // $('#next').click(function(){
    //     $(".match_box input").each(function(index) {
    //       if ($(this).is(':checked')) {
    //           var mainValue = $(this).val();
    //           allvalues.push(mainValue);
    //            $.unique(allvalues.sort());
    //            allvalues = allvalues.filter(function( element ) {
    //               return element !== undefined;
    //            });
    //       }
    //     });
    //   console.log(allvalues);
    //   var spacesReplaced;
    //   let text = allvalues.toString();
    //         spacesReplaced = text.replace(/([-.€~!@#$%^&*()_+=`{}\[\]\|\\:;' <>])+/g, '-');
    //         var n = spacesReplaced.replaceAll(',', '+');
    //         var ren = n.replaceAll('-/-', '-');
    //         var len = ren.replaceAll('-+', '-');
    //         var app = len.toLowerCase();
    //         a = '/blogs/coaching/tagged',
    //         l = location.origin,
    //         u = l + a + "/" + app;
    //       var pageURL = u;
    //       $('#result_match').attr('href', pageURL)
    //         // console.log(pageURL);
    // });


  
   

    // if (localStorage.getItem("names") !== null && localStorage.getItem("names")) {
         
    //      var newvalue =  nameUpdate + 1;
    //      $('.form_btn').click(function(){
    //       var nameUpdate = $(this).data('submit');
    //       var newvalue = 
    //       names.push(nameUpdate);
    //       localStorage.setItem("names", JSON.stringify(names));
    //       console.log(nameUpdate);
    //     });
    // }
    


